import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2, Search } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ event: "", user_email: "", order_id: "" });

  const load = async () => {
    setLoading(true);
    try {
      const q = new URLSearchParams();
      Object.entries(filters).forEach(([k, v]) => v && q.append(k, v));
      const { data } = await api.get(`/audit-logs?${q.toString()}`);
      setLogs(data);
    } catch (e) {
      toast.error("Erro");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filters]);

  return (
    <div className="space-y-4" data-testid="logs-page">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-slate-500">Auditoria</div>
        <h1 className="text-3xl font-black tracking-tighter">Logs e Auditoria</h1>
        <p className="text-sm text-slate-600 mt-1">Histórico completo de operações do Vyntric.</p>
      </div>

      <div className="border border-slate-200 bg-white p-3 grid grid-cols-1 md:grid-cols-4 gap-2">
        <Input testid="log-search-event" placeholder="Evento (ex: order.approved)" value={filters.event} onChange={(v) => setFilters({ ...filters, event: v })} />
        <Input testid="log-search-user" placeholder="Email do usuário" value={filters.user_email} onChange={(v) => setFilters({ ...filters, user_email: v })} />
        <Input testid="log-search-order" placeholder="Order ID" value={filters.order_id} onChange={(v) => setFilters({ ...filters, order_id: v })} />
        <button onClick={load} data-testid="logs-refresh" className="px-3 py-2 text-xs font-bold uppercase tracking-wider border border-slate-300 hover:border-slate-900 hover:bg-slate-900 hover:text-white">
          Buscar
        </button>
      </div>

      <div className="table-wrap">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200 text-[10px] uppercase tracking-widest text-slate-600">
            <tr>
              <th className="text-left px-3 py-2.5">Timestamp</th>
              <th className="text-left px-3 py-2.5">Evento</th>
              <th className="text-left px-3 py-2.5">Usuário</th>
              <th className="text-left px-3 py-2.5">Pedido</th>
              <th className="text-left px-3 py-2.5">Detalhes</th>
            </tr>
          </thead>
          <tbody>
            {loading && (<tr><td colSpan="5" className="py-10 text-center"><Loader2 className="inline w-5 h-5 animate-spin" /></td></tr>)}
            {!loading && logs.length === 0 && (<tr><td colSpan="5" className="py-10 text-center text-sm text-slate-500">Nenhum log.</td></tr>)}
            {logs.map((l) => (
              <tr key={l.id} className="t-row border-b border-slate-100" data-testid={`log-row-${l.id}`}>
                <td className="px-3 py-2.5 font-mono text-[11px] text-slate-600">{new Date(l.timestamp).toLocaleString("pt-BR")}</td>
                <td className="px-3 py-2.5"><span className="font-mono text-xs font-bold bg-slate-100 px-1.5 py-0.5">{l.event}</span></td>
                <td className="px-3 py-2.5 font-mono text-xs">{l.user_email || "-"}</td>
                <td className="px-3 py-2.5 font-mono text-xs text-slate-600">{l.order_id?.slice(0, 8) || "-"}</td>
                <td className="px-3 py-2.5 font-mono text-[10px] text-slate-500">{JSON.stringify(l.details || {})}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Input({ testid, placeholder, value, onChange }) {
  return (
    <div className="relative">
      <Search className="w-4 h-4 absolute left-2.5 top-2.5 text-slate-400" />
      <input data-testid={testid} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} className="pl-8 w-full border border-slate-300 rounded-sm px-2 py-2 text-sm focus:outline-none focus:border-[#002EA6]" />
    </div>
  );
}
